<template>
  <div :class="['payment-method', { 'payment-method_selected': info.selected, 'payment-method_disabled': disabled }]">
    <div class="payment-method__icon">
      <payment-icons :icon="icon" />
    </div>

    <div class="payment-method__text">
      {{ title }}
    </div>

    <div
      v-if="info.selected"
      class="payment-method__selected-icon"
    >
      <f-sprite-icon :icon-link="$options.icons.IconCheck.id" />
    </div>
  </div>
</template>

<script>
import PaymentIcons from '@/components/payment/payment-methods-modal/payment-icons.vue';

import IconCheck from '@icons/check.svg';

export default {
  name: 'payment-method',

  components: {
    PaymentIcons,
  },

  inject: ['adaptive'],

  icons: {
    IconCheck,
  },

  props: {
    info: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    title() {
      return this.info.title;
    },

    icon() {
      return !this.adaptive.isMobile && this.info?.altIcon
        ? this.info.altIcon
        : this.info.icon;
    },
  },
};
</script>

<style lang="scss">
.payment-method {
  display: flex;
  align-items: center;
  margin-top: 8px;
  padding: 11px 10px;
  border-radius: 4px;
  border: 1px solid $gray_lu;

  &:first-child {
    margin-top: 0;
  }

  &_selected {
    border: 2px solid $blue;
    pointer-events: none;
  }

  &_disabled {
    pointer-events: none;
  }

  &__icon {
    display: flex;
    align-items: center;

    img {
      max-height: 20px;
    }
  }

  &__text {
    font-size: 12px;
    line-height: 20px;
    margin-left: 14px;
  }

  &__selected-icon {
    width: 16px;
    height: 16px;
    margin-left: auto;
    color: $blue;
  }
}

@include breakpoint("tablet") {
  .payment-method {
    padding: 15px 16px;

    &__icon {
      height: 24px;
    }

    &__text {
      font-size: 14px;
      line-height: 24px;
    }
  }
}

@include breakpoint("desktop") {
  .payment-method {
    cursor: pointer;
  }
}
</style>
